import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'jquery/dist/jquery';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
// import {makeServer} from './Server'

// if (process.env.NODE_ENV === "development") {
//   makeServer({ environment: "development" });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
